import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ifElse } from 'aa_common/front-end/helpers'
import { DATE_FORMAT } from 'common/constants'
import { formatDate } from 'common/helpers'
import { getNs } from 'common/i18n-config'

import { acceleratedEventLogStore } from '../../store/accelerated-log'
import { Column, Header, IconWrapper, PlannedWrapper, Title } from './styles'

const { t, useNsReady } = getNs(['components/organisms/internal-control/log-list-item-detail'])

export const PlannedDate = () => {
  useNsReady()

  const adjustHistory = acceleratedEventLogStore.useSlice(state => state.data)

  return (
    <PlannedWrapper>
      <Header>
        <span>{t('planned_date')}</span>
      </Header>
      <Column>
        <Title>{t('before_change')}</Title>
        <div>
          {ifElse(
            adjustHistory?.before?.selected_date,
            formatDate(adjustHistory?.before?.selected_date, DATE_FORMAT),
            t('empty_date')
          )}
        </div>
      </Column>
      <IconWrapper>
        <FontAwesomeIcon icon={faArrowRight} style={{ color: '#747474', fontSize: '11px' }} />
      </IconWrapper>
      <Column>
        <Title>{t('after_change')}</Title>
        <div>
          {ifElse(
            adjustHistory?.after?.selected_date,
            formatDate(adjustHistory?.after?.selected_date, DATE_FORMAT),
            t('empty_date')
          )}
        </div>
      </Column>
    </PlannedWrapper>
  )
}
